// File: src/components/MatchFlow/TraditionalPortalHeader.jsx
import React, { useEffect, useMemo, useState } from 'react';

const styles = {
  /* match MixerPortalHeader container sizing & typography */
  container: {
    maxWidth: 600,
    width: '94%',
    margin: '0 auto',
    textAlign: 'center',
    padding: '0px 0 0px',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    color: '#111827',
  },

  /* match RevealIntroWizardPage heading */
  headerTop: {
    fontSize: 'clamp(1.15rem, 2.6vw, 1.05rem)',
    fontWeight: 900,
    letterSpacing: '0.06em',
    lineHeight: 1.15,
    margin: '0px 0 0 0',
    color: '#000',
  },
  headerBottom: {
    fontSize: 'clamp(1.8rem, 4.2vw, 2.2rem)',
    lineHeight: 1.25,
    marginTop: 8,
    fontWeight: 900,
    letterSpacing: '-0.01em',
    color: '#0B1020',
  },
};

export default function TraditionalPortalHeader({
  userId,
  firstName: fnProp = '',
  eventName = 'Event',
  roundStartTimes = [],
  nextRoundStartsAt = null,
}) {
  const [firstName, setFirstName] = useState(fnProp || null);

  useEffect(() => {
    if (firstName || !userId) return;
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/users/${userId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        });
        const data = await res.json();
        if (data?.firstName) setFirstName(data.firstName);
      } catch (err) {
        console.error('[TraditionalPortalHeader] fetch firstName →', err);
      }
    })();
  }, [firstName, userId]);

  const nextRoundDate = useMemo(() => {
    if (nextRoundStartsAt) return new Date(nextRoundStartsAt);
    return roundStartTimes.map((ts) => new Date(ts)).find((d) => d > new Date()) || null;
  }, [nextRoundStartsAt, roundStartTimes]);

  const diffToParts = (target) => {
    if (!target) return { h: '--', m: '--', s: '--' };
    const diff = target - Date.now();
    if (diff <= 0) return { h: '00', m: '00', s: '00' };
    return {
      h: String(Math.floor(diff / 3_600_000)).padStart(2, '0'),
      m: String(Math.floor((diff % 3_600_000) / 60_000)).padStart(2, '0'),
      s: String(Math.floor((diff % 60_000) / 1_000)).padStart(2, '0'),
    };
  };

  const [countdown, setCountdown] = useState(diffToParts(nextRoundDate));

  useEffect(() => {
    setCountdown(diffToParts(nextRoundDate));
    if (!nextRoundDate) return;
    const id = setInterval(() => setCountdown(diffToParts(nextRoundDate)), 1000);
    return () => clearInterval(id);
  }, [nextRoundDate]);

  const currentRound = useMemo(() => {
    const idx = roundStartTimes.findIndex((ts) => new Date(ts) > new Date());
    return idx === -1 ? roundStartTimes.length : idx + 1;
  }, [roundStartTimes]);

  return (
    <div style={styles.card}>
      <div style={styles.container}>
        {/* Heading — match RevealIntroWizardPage */}
        <div style={styles.headerTop}>
          {`WELCOME ${firstName ? firstName.toUpperCase() : '…'} TO`}
        </div>
        <div style={styles.headerBottom}>{eventName}</div>
      </div>
    </div>
  );
}
